import { useEffect, useState } from "react";
import { api } from "./api";

/**
 * Polls the admin contact-requests endpoint and exposes the unread count.
 * Used to show a red blinking badge in the Shell menu and on the dashboard
 * banner. Cheap (only the count + a small list payload) and self-cleaning.
 */
export default function useContactRequestsUnread(role, intervalMs = 20000) {
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (role !== "admin") return undefined;
    let alive = true;
    async function tick() {
      try {
        const { data } = await api.get("/admin/contact-requests");
        if (alive) setUnread(data.unread || 0);
      } catch {
        /* fail-quiet — badge simply stays at last known value */
      }
    }
    tick();
    const id = setInterval(tick, intervalMs);
    return () => { alive = false; clearInterval(id); };
  }, [role, intervalMs]);

  return unread;
}
